(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileDetailController', DocumentFileDetailController);

    DocumentFileDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity', 'translationHandler'];

    function DocumentFileDetailController($scope, $rootScope, previousState, entity, translationHandler) {
        var vm = this;

        vm.documentFile  = entity;
        if (vm.documentFile && vm.documentFile.filename) {
            translationHandler.setSubject(vm.documentFile.filename, 'eDocumentsApp.documentFile.home.title');
        }
        vm.previousState = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:documentFileUpdate', function (event, result) {
            vm.documentFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
